<i18n lang="yaml">
  pt:
    go: "Ir"
</i18n>

<template>
  <li
    data-grid
    :class="dynamicClasses"
    class="step grid--va-center p-relative px-3"
  >
    <span
      class="step__icon me-4"
      data-grid="center-center"
    >
      <CheckIcon v-if="step.done" />
    </span>

    <span class="step__label">
      {{ step.label }}
    </span>

    <router-link
      v-if="step.route"
      :to="step.route"
      data-grid="center"
      class="step__link grid--va-center p-absolute opacity-0"
    >
      {{ $t('go') }}

      <ArrowNarrowRightIcon />
    </router-link>
  </li>
</template>

<script>
import { defineComponent } from 'vue'

import CheckIcon from '../../../icons/CheckIcon'
import ArrowNarrowRightIcon from '../../../icons/ArrowNarrowRightIcon'

export default defineComponent({
  name: 'StepItem',

  components: {
    CheckIcon,
    ArrowNarrowRightIcon
  },

  props: {
    step: {
      type: Object,
      required: true
    }
  },

  computed: {
    dynamicClasses () {
      const { done } = this.step

      return {
        done
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .step {
    min-height: 55px;

    &:hover:after {
      opacity: .1;
      visibility: visible;
    }

    &:after {
      content: '';

      opacity: 0;
      visibility: hidden;
      transition: .4s ease-in-out;

      width: 100%;
      height: 55px;
      background-color: var(--primary);

      top: 0;
      left: 0;
      position: absolute;
    }

    &:not(.done) {
      background-color: rgb(var(--primary));
    }

    &__icon {
      --borderColor: rgb(var(--gray9));

      width: 15px;
      height: 15px;

      border-radius: 50%;
      color: rgb(var(--white));
      border: solid 1px var(--borderColor);

      .done & {
        --borderColor: rgb(var(--green1));

        background-color: rgb(var(--green1));
      }

      svg {
        width: 80%;
        height: 80%;
      }
    }

    &__label {
      color: rgb(var(--gray1));
      font: 400 1.3rem "Nunito", sans-serif;

      .done & {
        color: rgb(var(--gray11));
        text-decoration: line-through;
      }
    }

    &__link {
      z-index: 1;
      right: 10px;

      width: 50px;
      height: 25px;
      padding: 3px;
      border-radius: 4px;

      color: var(--primary);
      font: 400 1.2rem "Nunito", sans-serif;

      background-color: rgb(var(--white));
      box-shadow: 0 0 15px -3px rgb(var(--gray9));

      visibility: hidden;
      transform: translateX(-10px);
      transition: all .4s ease-in-out;

      svg {
        width: 12px;
        margin-inline: 10px 0;
      }

      .step:hover & {
        opacity: 1;
        visibility: visible;
        transform: translateX(0);
      }
    }
  }
</style>
